<!-- ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- -->
<ng-container>
    <div class="hid-modal__container">

        <div class="hid-modal__header-headline hid-spacing__mb-02">
            <h2 class="hid-modal__header-headline--primary" id="title">Session Expiry</h2>
        </div>

        <div class="hid-modal__body padding-x-0">
            <div class="hid-flex hid-flex-ai-start">
                <div *ngIf="dialogData?.icon?.show">
                    <ng-container *ngIf="dialogData.icon?.custom">
                        <mat-icon class="hid-spacing__mr-01" [svgIcon]=dialogData?.icon?.name></mat-icon>
                    </ng-container>
                    <ng-container *ngIf="!dialogData.icon?.custom">
                        <mat-icon class="hid-spacing__mr-01 error-state">{{dialogData?.icon?.name}}</mat-icon>
                    </ng-container>
                </div>
                <div class="dialog-content" [innerHtml]="dialogMessage">
                </div>
            </div>
        </div>

    </div>

    <footer class="hid-modal__footer padding-x-0">
        <button id="button_secondary" *ngIf="dialogData?.button?.logout" type="button"
            class="hid-button hid-button--secondary" (click)="dialogCancel(true)">LOGOUT</button>
        <button id="button_primary" type="button" class="hid-button hid-button--primary"
            (click)="dialogSuccess(dialogData?.action)">{{buttonText}}</button>
    </footer>
</ng-container>